import { motion } from "framer-motion";
import { Separator } from "@/components/ui/separator";
import { Quote } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

const testimonials = [
  {
    quote: "Paul was always a proactive, result-oriented, responsible and technically sound Manager who was always ready to get the job done and offer sound advice.",
    author: "Fitzroy Rampersad",
    role: "UNHCR",
  },
  {
    quote: "Paul made a huge and difficult task manageable for our NGO and we now have a very secure and efficient system in place.",
    author: "Mrs. Jan Bovey",
    role: "NGO Director",
  },
  {
    quote: "Paul taught me a lot about leadership and management. He is professional, committed, and enthusiastic.",
    author: "Phechkong Lim",
    role: "Khalibre",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-36 bg-[#0a192f] overflow-hidden"
    >
      <div className="blueprint-grid absolute inset-0 opacity-10" />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <motion.p
          {...fadeInUp}
          transition={{ duration: 0.6 }}
          className="font-body text-fluid-caption tracking-[0.3em] uppercase text-gold mb-4"
        >
          Proof People Can Feel
        </motion.p>

        <motion.h2
          {...fadeInUp}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-heading font-bold text-fluid-h2 uppercase tracking-tight text-slate-50 mb-4"
        >
          Client <span className="text-gold-gradient">Blueprints</span>
        </motion.h2>

        <motion.p
          {...fadeInUp}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="font-body text-fluid-body text-slate-400 max-w-2xl mb-4"
        >
          I install systems that hold up. People notice.
        </motion.p>

        <Separator className="bg-gold/20 mb-16 max-w-xs" />

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.author}
              data-testid={`testimonial-card-${i}`}
              className="card-glow relative bg-[#0f172a] border border-slate-800 rounded-sm p-8 hover:border-gold/30 transition-all duration-400"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15, duration: 0.6 }}
            >
              {/* Quote Icon */}
              <Quote size={28} className="text-gold/30 mb-5" />

              {/* Quote Text */}
              <p className="font-accent italic text-slate-300 text-fluid-body mb-8">
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="mt-auto">
                <Separator className="bg-gold/20 mb-4" />
                <p className="font-heading font-bold text-fluid-small text-slate-50 uppercase tracking-wide">
                  {t.author}
                </p>
                <p className="font-body text-fluid-caption text-gold/80">{t.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
